import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const LearnerManagementLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.leaner_management',
    link: '/groups/list/learners',
    icon: 'navigation-link__list-item',
});